
import {debounceTime} from 'rxjs/operators';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormQuestion } from './model/FormQuestion';
import { FormAlternative } from './model/FormAlternative';
import { FormValidator } from './service/FormValidator';
import { Form } from './model/Form';
import { Subject ,  Observable } from 'rxjs';

@Component({
    selector: 'app-form-alternative',
    templateUrl: './formAlternative.component.html',
    styleUrls: ['formAlternative.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormAlternativeComponent implements OnInit {

  @Input() form: Form;
  @Input() question: FormQuestion;
  @Input() readonly = false;
  public alternativeSelections = new Subject<any>();
  selectedAlternativeText: string;

  get selectedAlternative(): FormAlternative {
    if (!this.question.answer || !this.question.alternatives) {
      return undefined;
    }
    return this.question.alternatives
      .filter(a => a.id === this.question.answer)[0];

  }

  constructor(private service: FormValidator) {

    const subscription = this.alternativeSelections.pipe(
      debounceTime(250))
      .subscribe(this.onSelect.bind(this));

   }

   ngOnInit() {
     if (this.readonly && this.question.alternatives) {
      const selectedAlternative = this.question.alternatives.find(a => a.id === this.question.answer);
      if (selectedAlternative) {
        this.selectedAlternativeText = selectedAlternative.text;
      }
     }
   }


  onSelect(selected: FormAlternative) {
    this.service.setAnswer(this.form.id, this.question.id, selected.id);
  }

}
